import { Component, createRef } from 'react'
import _ from 'lodash'
import clx from 'classnames'
import moment from 'moment'
import { Button } from '@vzmi/shp_shared_compo'
import { DEFAULT_DASHBOARD_DATE_RANGE, YESTERDAY } from '../../../../../../constants/date'
import { showOnlyNumber, showOnlyPid } from '../../../../../../lib/formatter'
import { getUIFormatDate, DATE_FORMAT } from '../../../../../../lib/MomentHelper'
import FormRow from '../../../../../Common/NewDashboard/FormRow/FormRow'
import Collapse from '../../../../../Common/NewDashboard/Collapse/Collapse'
import { IconExportButton } from '../../../../../Common/ExportButton'
import {
  RangePickerField,
  RadioGroupInputField,
  CheckboxGroupField,
  InputField
} from '../../../../../Common/Form'
import {
  formDecorator,
  Field,
  FormValueSelector
} from '../../../../../Common/forms'
import styles from './SearchForm.css'
import {
  LISTING_TYPE,
  LISTING_TYPE_OPTIONS
} from '../../../constants/listing'
import {
  CARRIER,
  CARRIER_FULL_OPTIONS
} from '../../../constants/carrier'
import DateHelper from '../../../../../../lib/DateHelper'
import { calendarDisableDate } from '../../../Shared'

export const FIELD = {
  MAIN_RANGE: 'mainRange',
  COMPARISON_RANGE: 'comparisonRange',
  LISTING_TYPE: 'listingType',
  LISTING_ID: 'listingId',
  CARRIERS: 'carriers'
}

export const validateListingId = values => {
  const listingType = values[FIELD.LISTING_TYPE]
  const listingId = values[FIELD.LISTING_ID]

  if (listingType === LISTING_TYPE.ALL) {
    return {}
  }

  if (listingId === '') {
    return { [FIELD.LISTING_ID]: '請輸入賣場編號' }
  }

  return {}
}

export const validateCarriers = values => {
  const carriers = values[FIELD.CARRIERS]

  if (_.isEmpty(carriers)) {
    return { [FIELD.CARRIERS]: '至少要選一種裝置' }
  }

  return {}
}

const syncValidator = values => {
  let errors = {}
  errors = _.merge(errors, validateListingId(values))
  errors = _.merge(errors, validateCarriers(values))
  return errors
}

export const CONFIG = {
  form: 'PAGE_VIEWS_DAILY_FORM',
  validate: syncValidator,
  initialValues: {
    [FIELD.MAIN_RANGE]: DEFAULT_DASHBOARD_DATE_RANGE,
    [FIELD.COMPARISON_RANGE]: [],
    [FIELD.LISTING_TYPE]: LISTING_TYPE_OPTIONS[0].value,
    [FIELD.LISTING_ID]: '',
    [FIELD.CARRIERS]: [CARRIER_FULL_OPTIONS[0].value]
  }
}

const CONVERTED_CARRIER_FULL_OPTIONS = _.map(CARRIER_FULL_OPTIONS, option => {
  if (option.value !== CARRIER.ALL) {
    return option
  }
  return {
    ...option,
    label: '全部'
  }
})

class SearchForm extends Component {
  constructor (props) {
    super(props)
    this.collapse = createRef()
    /*
     資料查詢區塊
     僅接受半年內之資料查詢
     起：兩年以前之日期不可選擇
     迄且現在是 12:00:00 以後：今天(含)以後之日期不可選擇
     迄且現在是 11:59:59 以前：前一天(含)以後之日期不可選擇
   */
    const {
      startMinDate
    } = DateHelper.getSaleStatDefaultPeriod()
    const [start, end] = DEFAULT_DASHBOARD_DATE_RANGE
    const formatStartDate = getUIFormatDate(start)
    const formatEndDate = getUIFormatDate(end)
    this.state = {
      periodStartMinDate: startMinDate,
      periodEndMaxDate: YESTERDAY,
      periodStart: formatStartDate,
      secondPeriodStart: formatStartDate,
      periodEnd: formatEndDate,
      secondPeriodEnd: formatStartDate
    }
  }

  componentDidMount () {
    this.props.onFormInit(this.props)
  }

  // 調整「起」的日期後，則「迄」跟著自動變動：
  // 「起」＋六個月 (180 天) ; 之後的日期 disable 不可選
  // 若「起」＋六個月 (180 天)  > 昨日，則為昨日
  // 若為購中店，則不得早於上線日期
  disabledDate = dateMoment => {
    const { isSeller, onlineDate } = this.props
    const {
      periodEndMaxDate,
      periodStartMinDate,
      periodStart
    } = this.state
    return (isSeller && onlineDate)
      ? dateMoment < moment(onlineDate, DATE_FORMAT.UI)
      : dateMoment < moment(periodStartMinDate) ||
      dateMoment >= calendarDisableDate(periodEndMaxDate, periodStart)
  }

  onCalendarChange = dateMoment => {
    const periodStart = getUIFormatDate(dateMoment[0])
    this.setState({
      periodStart
    })
  }

  onMainRangeChange = (dateMoment, dateString) => {
    const [periodStart, periodEnd] = dateString
    this.setState({
      periodStart,
      periodEnd
    })
  }

  secondDisabledDate = dateMoment => {
    const { isSeller, onlineDate } = this.props
    const {
      periodEndMaxDate,
      periodStartMinDate,
      secondPeriodStart
    } = this.state
    return (isSeller && onlineDate)
      ? dateMoment < moment(onlineDate, DATE_FORMAT.UI)
      : dateMoment < moment(periodStartMinDate) ||
    dateMoment >= calendarDisableDate(periodEndMaxDate, secondPeriodStart)
  }

  secondOnCalendarChange = dateMoment => {
    const secondPeriodStart = getUIFormatDate(dateMoment[0])
    this.setState({
      secondPeriodStart
    })
  }

  onSecondMainRangeChange = (dateMoment, dateString) => {
    const [secondPeriodStart, secondPeriodEnd] = dateString
    this.setState({
      secondPeriodStart,
      secondPeriodEnd
    })
  }

  handleListingChange = (e, value) => {
    const { onListingChange, isSeller, change } = this.props
    // 如果選擇「指定賣場」且為購中店，自動設定裝置為「全部」
    if (value === LISTING_TYPE.ORDER && isSeller) {
      change(FIELD.CARRIERS, [CARRIER.ALL])
    }
    // call 原有的 onListingChange
    if (onListingChange) {
      onListingChange(e, value)
    }
  }

  onSubmit = (e) => {
    this.props.handleSubmit(e)
    const comparisonRange = _.get(this.props, 'reduxFormState.values.comparisonRange', [])
    // 打開比較日期但沒有輸入在查詢時會自動關閉
    if (_.isEmpty(comparisonRange)) {
      this.collapse.current.open(false)
    }
  }

  render () {
    const {
      onCollapseChange,
      onCarriersChange,
      onExportExcel,
      disableExportBtn,
      isSeller = false,
      onlineDate = ''
    } = this.props
    return (
      <form
        onSubmit={this.onSubmit}
        className={styles.searchForm}
      >
        <FormRow
          label='日期區間'
          labelAlign='center'
        >
          <Field
            key={FIELD.MAIN_RANGE}
            name={FIELD.MAIN_RANGE}
            data-role={FIELD.MAIN_RANGE}
            className={styles.rangePicker}
            component={RangePickerField}
            onChange={this.onMainRangeChange}
            disabledDate={this.disabledDate}
            onCalendarChange={this.onCalendarChange}
            allowClear={false}
          />
        </FormRow>
        <FormRow className={styles.comparisonRangePickerRow}>
          <Collapse
            ref={this.collapse}
            id='page-views-daily-comparison-collapse'
            openText='比較日期'
            closeText='取消比較'
            tipsText={`可查詢最早日期為${onlineDate || '兩年前'}，起迄區間最長為六個月，每日中午更新`}
            className={styles.rangePicker}
            actionClassName={styles.actionClassName}
            onChange={onCollapseChange}
          >
            <Field
              key={FIELD.COMPARISON_RANGE}
              name={FIELD.COMPARISON_RANGE}
              data-role={FIELD.COMPARISON_RANGE}
              className={clx(styles.rangePicker, styles.comparisonRangePicker)}
              component={RangePickerField}
              onChange={this.onSecondMainRangeChange}
              disabledDate={this.secondDisabledDate}
              onCalendarChange={this.secondOnCalendarChange}
            />
          </Collapse>
        </FormRow>
        <FormRow
          label='賣場'
          labelAlign='top'
        >
          <Field
            key={FIELD.LISTING_TYPE}
            name={FIELD.LISTING_TYPE}
            data-role={FIELD.LISTING_TYPE}
            className={styles.listingType}
            component={RadioGroupInputField}
            buttonStyle='outline'
            options={LISTING_TYPE_OPTIONS}
            onChange={this.handleListingChange}
          />
        </FormRow>
        <FormValueSelector fieldName={FIELD.LISTING_TYPE}>
          {listingType => {
            const isFieldVisible = listingType === LISTING_TYPE.ORDER
            return (
              <FormRow
                className={clx(
                  styles.listingIdRow,
                  { hidden: !isFieldVisible }
                )}
              >
                <Field
                  key={FIELD.LISTING_ID}
                  name={FIELD.LISTING_ID}
                  data-role={FIELD.LISTING_ID}
                  className={styles.listingId}
                  component={InputField}
                  placeholder='輸入賣場編號'
                  parse={isSeller
                    ? showOnlyPid
                    : showOnlyNumber}
                />
              </FormRow>
            )
          }}
        </FormValueSelector>
        <FormValueSelector fieldName={FIELD.LISTING_TYPE}>
          {listingType => {
            const shouldDisableCarriers = listingType === LISTING_TYPE.ORDER && isSeller
            return (
              <FormRow
                label='裝置'
                labelAlign='top'
              >
                <Field
                  key={FIELD.CARRIERS}
                  name={FIELD.CARRIERS}
                  data-role={FIELD.CARRIERS}
                  component={CheckboxGroupField}
                  options={CONVERTED_CARRIER_FULL_OPTIONS}
                  onChange={onCarriersChange}
                  disabled={shouldDisableCarriers}
                />
              </FormRow>
            )
          }}
        </FormValueSelector>
        <FormRow labelAlign='top'>
          <Button
            type='submit'
            data-role='search-btn'
            size='large'
            className={styles.searchBtn}
          >
            查詢
          </Button>
          <div className={styles.exportButton}>
            <IconExportButton
              disabled={disableExportBtn}
              data-role='pv-daily-export-button'
              onClick={onExportExcel}
              label='下載整筆檔案'
            />
          </div>
        </FormRow>
      </form>
    )
  }
}

const SearchFormWithDecorator = formDecorator(CONFIG)(SearchForm)

export default SearchFormWithDecorator
